var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisible,
          expression: "isVisible"
        }
      ],
      staticClass: "zoom-container"
    },
    [_c("zoom-slider-wrapper"), _vm._v(" "), _c("zoom-button-list")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/uScope/js/extensions/zoom/ZoomContainer.vue?vue&type=template&id=378ea3e4&scoped=true&
// module id = 518
// module chunks = 0